import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AgentsTableControls from './AgentsTableControls';
import { contactToolTips, tabModes } from '../../constants/agentProductionConstants';
import Table from '../../../common/components/table/agGrid/Table';
import { tableViews } from '../../../common/components/table/agGrid/tableViews';
import AgentsFloatingActionBar from '../common/AgentsFloatingActionBar';
import { useAgentTableDownload } from '../../hooks/agentTableDownload';
import { views } from '../../constants/savedAgents';

const ContactInformation = ({ agentData, columns, additionalTableHeaders, setColumns, state, setState, isActive }) => {
    const [isTableSelected, setIsTableSelected] = useState(true);
    const {
        gridRef,
        selectedCount,
        showAddToListModal,
        setShowAddToListModal,
        handleDismiss,
        handleDownloadClick,
    } = useAgentTableDownload({ state, setState, selectedView: views.contactInformation });

    const agentsTableControlsProps = {
        tabMode: tabModes.CONTACT_INFORMATION,
        hasShowHideColumnsButton: true,
        columns,
        setColumns,
        isTableSelected,
        setIsTableSelected,
        popoverClassName: 'contact-information'
    };

    return (
        <>
            <AgentsTableControls {...agentsTableControlsProps} />
            <Table
                gridRef={gridRef}
                tableView={tableViews.contactInformation}
                rowData={agentData}
                columns={columns}
                additionalTableHeaders={additionalTableHeaders}
                tableTitleWithTooltips={contactToolTips}
                rowSelection={'multiple'}
                suppressRowClickSelection={true}
                rowMultiSelectWithClick={true}
            />
            {isActive && (
                <AgentsFloatingActionBar
                    selectedCount={selectedCount}
                    showAddToListModal={showAddToListModal}
                    setShowAddToListModal={setShowAddToListModal}
                    onDismiss={handleDismiss}
                    onDownloadClick={handleDownloadClick}
                />
            )}
        </>
    );
};

ContactInformation.propTypes = {
    agentData: PropTypes.arrayOf(PropTypes.object),
    additionalTableHeaders: PropTypes.arrayOf(PropTypes.object),
    columns: PropTypes.arrayOf(PropTypes.object),
    setColumns: PropTypes.func,
    state: PropTypes.object,
    setState: PropTypes.func,
    isActive: PropTypes.bool,
};

export default ContactInformation;
